import axios from 'axios'
import { Message } from 'element-ui'
import { getToken } from './token'
import {handleErrorResponse} from "./hadleRequestErrors";

const timer = 100 * 1000

const service = axios.create({
    baseURL: `${process.env.VUE_APP_BLOG_API}/blog/api/admin/`,
    headers: {
        Accept: 'application/json'
    },
    timeout: timer
})
service.defaults.headers['Content-Type'] = 'application/json'

service.interceptors.request.use(
    config => {
            config.headers['Authorization'] = getToken().replace('bearer', 'Bearer')
        return config
    },
    error => {
        Promise.reject(error)
    }
)

service.interceptors.response.use(
    response => {
        const res = response.data
        if (response.status !== 200
            && response.status !== 201
            && response.status !== 204)
        {
            Message({
                message: res.message,
                type: 'error',
                duration: 5 * 1000
            })
            return Promise.reject('error')
        } else {
            return response.data
        }
    },
    error => handleErrorResponse(error)
)

export default service